import { SiteGraphic } from "../../components/SiteGraphic/SiteGraphic";
import { Menu } from "../../modules/Menu/Menu";
import { SiteModulesList } from "../../siteModules/SiteModulesList";
import { SiteModulesListWrapper } from "./components/SiteModulesListWrapper/SiteModulesListWrapper";
import { SiteFontSetter } from "./components/SiteFontSetter/SiteFontSetter";
import { ThemeStylesSetter } from "./components/ThemeStylesSetter/ThemeStylesSetter";
import { isSiteV2 } from "../../utils/isSiteV2";
import { LanguageProvider } from "../../../contexts/LanguageContext";
import { loadSiteFonts } from "../../utils/LoadSiteFonts";
import { TLanguageCode } from "../../interfaces/IContentData";
import { IDesignTemplate } from "../../modules/EditDesignTemplate/utils/designTemplates";
import { generateSitePreview } from "./utils/generateSitePreview";
import { getStyleVariables } from "../../utils/getStyleVariables";
import styles from "./GeneratorSitePreview.module.scss";
import { useMemo } from "react";
import React from "react";
import { PreviewContext } from "../../../contexts/PreviewContext";

interface IProps {
    designTemplate: IDesignTemplate;
    scaleCssVariableName: `--site-preview-scale-${string}`;
}

const appLanguage = "sv";

export function GeneratorSitePreview(props: IProps) {
    // useMemo due to not generating new ids all the time
    const site = useMemo(() => generateSitePreview(props.designTemplate), [props.designTemplate]);

    loadSiteFonts(site.fonts);

    const getFirstLanguage = (): TLanguageCode => {
        if (isSiteV2(site) && site.availableLanguages?.length) {
            if (site.availableLanguages.find((lang) => lang.languageCode === appLanguage)) {
                return appLanguage;
            }
            return site.availableLanguages[0].languageCode;
        }
        return appLanguage;
    };

    return (
        <div
            className={styles.wrapper}
            style={
                {
                    "--site-preview-scale": "var(" + props.scaleCssVariableName + ")",
                } as React.CSSProperties
            }
            inert="true"
        >
            <div className={styles.scaler}>
                <div className={styles.content}>
                    <PreviewContext.Provider value={true}>
                        <LanguageProvider defaultLanguage={getFirstLanguage()}>
                            <SiteFontSetter style={getStyleVariables(site.fonts, site.colorScheme)}>
                                <ThemeStylesSetter site={site} backgroundColorOnBody={false}>
                                    {site.siteGraphic ? (
                                        <SiteGraphic type="SITE" siteGraphic={site.siteGraphic} editAvailable={false} />
                                    ) : null}
                                    <Menu site={site} editMode={false} editAvailable={false} />

                                    <SiteModulesListWrapper site={site}>
                                        <SiteModulesList editAvailable={true} site={site} />
                                    </SiteModulesListWrapper>
                                </ThemeStylesSetter>
                            </SiteFontSetter>
                        </LanguageProvider>
                    </PreviewContext.Provider>
                </div>
            </div>
        </div>
    );
}
